module.exports = __webpack_public_path__ + "media/images/symbols/scroll-down-a1aaad0cbb74de479ffff6534b48952d.svg";